<template>
  <transition
    name="expand"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave">
    <ul v-show="list.open" class="sub-items">
      <li class="sub-item"
          v-for="item in list.children"
          :key="item.node_id"
      >
        <div @click="itemClick(item)" :class="{'white--text':theme=='dark', 'black--text':theme!='dark', 'active-item': item.active}">
          <v-icon x-small :color="theme=='dark' ? 'white' : 'black'" v-if="item.children && item.children.length">{{item.open ? 'mdi-minus' : 'mdi-plus'}}</v-icon>
          <v-icon x-small :color="theme=='dark' ? 'white' : 'black'" v-else>{{item.icon}}</v-icon>
          {{ item.label }} <span class="blue--text" v-if="Number(item.badge) > 0">(+{{item.badge}})</span>
        </div>
        <nav-dropdown-panel class="subnav" v-if="item.children && item.children.length" :list="item" :theme="theme" :on-item-click="itemClick"/>
      </li>
    </ul>
  </transition>
</template>

<script>
export default {
  name: 'nav-dropdown-panel',
  props: [
    'list',
    'theme',
    'onItemClick'
  ],
  data: () => ({
  }),
  watch: {
    list (val) {
      console.log('nav-dropdown-panel list changed ', val)
    }
  },
  methods: {
    enter (el) {
      el.style.height = 'auto'
      const height = getComputedStyle(el).height
      el.style.height = 0
      getComputedStyle(el)
      setTimeout(() => {
        el.style.height = height
      })
    },
    afterEnter (el) {
      el.style.height = 'auto'
    },
    leave (el) {
      el.style.height = getComputedStyle(el).height
      getComputedStyle(el)
      setTimeout(() => {
        el.style.height = 0
      })
    },
    deactivateAll (item) {
      item.active = false
      if (!item.children) return
      item.children.map(itm => {
        itm.active = false
        if (itm.children) this.deactivateAll(itm)
      }, this)
    },
    itemClick (item) {
      this.deactivateAll(this.list)
      item.active = !item.active
      if (item.children && item.children.length) item.open = !item.open
      if (typeof this.onItemClick === 'function') {
        this.onItemClick(item)
      }
    }
  }
}
</script>

<style scoped>
.sub-items {
  list-style: none;
}
.sub-items .sub-item {
  position: relative;
  cursor: pointer;
  white-space: nowrap;
}
.sub-items .sub-item .subnav {
  padding-left: 20px;
  padding-right: 25px;
}
.active-item {
  font-weight: bolder;
  border-bottom: 1px solid #990000;
}
.expand-enter-active, .expand-leave-active {
  transition: height 0.5s ease-in-out;
  overflow: hidden;
}
</style>
